import { gsap } from "./gsap";

let cards = Array.from(document.querySelectorAll('.page-home--about .text-item'));

startAnim(cards);

function startAnim(array){
	if(array.length >= 4 ) {

		if(window.innerWidth >= 992) {
			gsap.fromTo(array[0], 2, {x:0, y: 0, opacity:0.75}, {x:0, y: -120, opacity:0, zIndex: 0, delay:0.03, ease: "none", onComplete: sortArray(array)});

			gsap.fromTo(array[1], 2, {x:30, y: 125, opacity:1, zIndex: 1}, {x:0, y: 0, opacity:0.75, zIndex: 0, ease: "none", color: 'transparent',});

			gsap.fromTo(array[2], 2, {x:0, y: 250, opacity:1}, {x:30, y: 125, opacity:1, zIndex: 1, ease: "none", color: 'white'});

			gsap.fromTo(array[3], 2, {x:0, y:400, opacity: 0, zIndex: 0}, {x:0, y:250, opacity: 0.75, zIndex: 0, ease: "none"}, );
		} else {
			gsap.fromTo(array[0], 2, {x:0, y: 0, opacity:0.75}, {x:0, y: -55, opacity:0, zIndex: 0, delay:0.03, ease: "none", onComplete: sortArray(array)});

			gsap.fromTo(array[1], 2, {x:0, y: 55, opacity:1, zIndex: 1}, {x:0, y: 0, opacity:0.75, zIndex: 0, ease: "none", color: 'transparent',});

			gsap.fromTo(array[2], 2, {x:0, y: 110, opacity:1}, {x:0, y: 55, opacity:1, zIndex: 1, ease: "none", color: 'white'});

			gsap.fromTo(array[3], 2, {x:0, y: 180, opacity: 0, zIndex: 0}, {x:0, y: 110, opacity: 0.75, zIndex: 0, ease: "none"}, );
		}
	}
}

function sortArray(array) {
	setTimeout(function(){
		let firstElem = array.shift();
		for (let item of array) {
			item.style.color = `transparent`;
			item.classList.remove('active');
		}
		array[2].classList.add('active');
		array.push(firstElem);

		return startAnim(array);
	},3000)
}